import React, { useState } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import VideoCollection from './VideoDatabase';


interface IVideoPlayerProps {
  videoIds: string[];
}

export const VideoPlayerJs: React.FC<IVideoPlayerProps> = (
  {
    videoIds
  }) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const playerRef = React.useRef<videojs.Player | null>(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  React.useEffect(() => {

    console.log('videoIds', videoIds);
    const totalVideoDuration = VideoCollection
      .filter(video => videoIds.includes(video.id))
      .reduce((acc, video) => acc + video.durationInMilliseconds, 0);

    const options = {
      autoplay: true,
      controls: true,
      responsive: true,
      fluid: true,
      // sources: [{
      //   src: `../assets/videos/${VideoCollection[0].src}`,
      //   type: 'video/mp4'
      // }]
    };

    // Make sure Video.js player is only initialized once
    if (!playerRef.current && videoRef.current) {
      videojs.log("Initializing Video.js player");
      const player = playerRef.current = videojs(videoRef.current, options, () => {
        videojs.log('player is ready');
        player.duration = () => totalVideoDuration / 1000;
        player.src({ src: `../assets/videos/${VideoCollection[0].src}`, type: 'video/mp4' });
      });

      videojs.log("Total video duration", totalVideoDuration);
      playerRef.current.duration(totalVideoDuration);

      player.on('timeupdate', () => {
        console.log('timeupdate currentTime', player.currentTime());
        const currentTime = player.currentTime();

        let elapsed = 0;
        for (let i = 0; i < VideoCollection.length; i++) {
          const videoDuration = VideoCollection[i].durationInMilliseconds / 1000;
          if (currentTime < elapsed + videoDuration) {
            if (i !== currentVideoIndex) {
              setCurrentVideoIndex(i);
              playerRef.current?.src({ src: `../assets/videos/${VideoCollection[i].src}`, type: 'video/mp4' });
              //playerRef.current?.currentTime(currentTime - elapsed);
            }
            break;
          }
          elapsed += videoDuration;
        }
      });

      player.on('seeked', () => {
        console.log('seeked currentTime', player.currentTime());
        const currentTime = player.currentTime();
        let elapsed = 0;
        for (let i = 0; i < VideoCollection.length; i++) {
          console.log('i', i);
          console.log('elapsed', elapsed);
          const videoDuration = VideoCollection[i].durationInMilliseconds / 1000;
          if (currentTime < elapsed + videoDuration) {
            if (i !== currentVideoIndex) {
              console.log('setCurrentVideoIndex', i);
              setCurrentVideoIndex(i);
              player.src({ src: `../assets/videos/${VideoCollection[i].src}`, type: 'video/mp4' });
              console.log('currentTime - elapsed', currentTime - elapsed);
              player.currentTime(currentTime);
            }
            break;
          }
          elapsed += videoDuration;
        }
      });

    } else if (playerRef.current) {
      console.log('playerRef.current', playerRef.current);
      const player = playerRef.current;

      if (options.autoplay !== undefined) {
        player.autoplay(options.autoplay);
      }
    }
  }, [videoRef, currentVideoIndex, videoIds]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        if (playerRef.current) {
          playerRef.current.off('ended');
          playerRef.current.off('timeupdate');
        }
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  console.log("We added this line to test the git diff command");

  return (
    <div data-vjs-player>
      <video ref={videoRef} className="video-js"/>
    </div>
  );
}

export default VideoPlayerJs;
